import { render, staticRenderFns } from "./TermsV2.vue?vue&type=template&id=afbb495e&scoped=true&"
import script from "./TermsV2.vue?vue&type=script&lang=js&"
export * from "./TermsV2.vue?vue&type=script&lang=js&"
import style0 from "./TermsV2.vue?vue&type=style&index=0&id=afbb495e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbb495e",
  null
  
)

export default component.exports